// El botón del frasco: qué perfume llevaste en este registro (22/9).
//
// Pedido del dueño: al registrar «Me lo puse» —en Qué me pongo y en
// Armar a mano— aparece un ícono de frasco que sirve para elegir el
// perfume. Viene ya elegido con el último que usaste (o, si nunca
// usaste ninguno, el último que cargaste): tocarlo abre la lista para
// cambiarlo o dejarlo «Sin perfume».
//
// ⚠️  LA PRESELECCIÓN SE VE SIEMPRE, CON NOMBRE. Un perfume que se
//     anota solo sin que lo veas ensuciaría su «hace cuánto» los días
//     que no te pusiste nada. Por eso el botón no es solo un ícono: dice
//     cuál va a quedar anotado, y se saca de un toque.
//
// La lista se abre DEBAJO, en el flujo, y no flotando: dentro de una
// tarjeta de outfit o de la barra de abajo del armador no hay dónde
// anclar un menú flotante sin que se corte.

import { useState } from "react";
import { t, useIdioma } from "./i18n";
import { fotoChica } from "./foto";
import { IconoFrasco } from "./Iconos";

export default function FrascoBoton({ perfumes, valor, onCambiar, nombreFuera }) {
  useIdioma();
  const [abierto, setAbierto] = useState(false);
  const lista = (perfumes || []).filter((p) => p.activo !== false);
  const elegido = lista.find((p) => p.id === valor);
  /* Un registro viejo puede tener un perfume que ya borraste: no está
   * en la lista, pero tiene nombre. Se muestra igual — si no, el botón
   * diría «Sin perfume» sobre un registro que sí lo tiene. */
  const nombre = elegido?.nombre || (valor ? nombreFuera : null);

  // Sin perfumes cargados no hay nada que elegir: el botón no aparece.
  if (!lista.length && !valor) return null;

  const elegir = (id) => {
    onCambiar(id);
    setAbierto(false);
  };

  return (
    <div className="frasco">
      <button
        type="button"
        className={`chip frasco-boton ${valor ? "chip-activo" : ""}`}
        onClick={() => setAbierto((v) => !v)}
        aria-expanded={abierto}
        title={t("frasco.titulo", "El perfume que llevaste")}
      >
        <IconoFrasco relleno={!!valor} />
        <span className="frasco-nombre">{nombre || t("frasco.sinPerfume", "Sin perfume")}</span>
      </button>

      {abierto && (
        <div className="frasco-lista" role="group" aria-label={t("frasco.elegir", "Elegir perfume")}>
          {lista.map((p) => (
            <button
              key={p.id}
              type="button"
              className={`chip ${p.id === valor ? "chip-activo" : ""}`}
              onClick={() => elegir(p.id)}
              aria-pressed={p.id === valor}
            >
              {fotoChica(p) ? (
                <img src={fotoChica(p)} alt="" className="frasco-mini" loading="lazy" decoding="async" />
              ) : (
                <IconoFrasco tamano={14} />
              )}
              <span>{p.nombre}</span>
            </button>
          ))}
          <button
            type="button"
            className={`chip ${!valor ? "chip-activo" : ""}`}
            onClick={() => elegir(null)}
            aria-pressed={!valor}
          >
            {t("frasco.sinPerfume", "Sin perfume")}
          </button>
        </div>
      )}
    </div>
  );
}

/**
 * El perfume de un registro, para el Historial y el Calendario: el
 * frasco y el nombre. Nada si el registro no tiene perfume.
 *
 * `enLinea` lo mete DENTRO de otro renglón en vez de darle uno propio.
 * Lo usa el Historial, donde el perfume va pegado a «Hoy · Trabajo
 * formal»: ahí un renglón entero para dos palabras costaba 18px por
 * tarjeta. Un <p> adentro de un <p> no es HTML válido —el navegador
 * cierra el de afuera y la tarjeta se parte— así que en ese modo la
 * caja es un <span>.
 */
export function PerfumeDelRegistro({ perfume, enLinea }) {
  useIdioma();
  if (!perfume) return null;
  const Caja = enLinea ? "span" : "p";
  return (
    <Caja
      className={`texto-mini perfume-registro ${enLinea ? "perfume-en-linea" : ""}`}
      title={t("frasco.conPerfume", "Perfume: {nombre}", { nombre: perfume.nombre })}
    >
      {fotoChica(perfume) ? (
        <img src={fotoChica(perfume)} alt="" className="frasco-mini" loading="lazy" decoding="async" />
      ) : (
        <IconoFrasco tamano={14} relleno />
      )}
      <span>{perfume.nombre}</span>
    </Caja>
  );
}
